// extracted by mini-css-extract-plugin
export default {"container":"mS-z","title":"nS-z","link":"oS-z"};